<template>
  <div
    class="table-v2-wrap"
    :class="{
      'table-v2-wrap--flush': flush,
      'table-v2-wrap--full-height': fullHeight,
    }"
  >
    <div
      class="table-v2-container"
      :class="{ 'table-v2--rtl': isRTL, 'table-v2--hover-rows': hoverRows }"
    >
      <table class="table-v2">
        <thead>
          <tr class="table-v2__header-row">
            <slot name="header" />
          </tr>
        </thead>
        <tbody>
          <slot name="body" />
        </tbody>
      </table>
    </div>
    <table-pagination-v2
      v-if="showPagination"
      class="table-v2__pagination"
      :current-page="currentPage"
      :total-pages="totalPages"
      :total-items="totalItems"
      :page-size="pageSize"
      :loading="loading"
      :disabled="disabled"
      :is-r-t-l="isRTL"
      @page-change="$emit('page-change', $event)"
      @update:currentPage="$emit('update:currentPage', $event)"
    />
  </div>
</template>

<script>
import TablePaginationV2 from './TablePaginationV2.vue';

export default {
  name: 'TableV2',
  components: { TablePaginationV2 },
  props: {
    isRTL: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hoverRows: {
      type: Boolean,
      default: true,
    },
    flush: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showPagination() {
      return this.totalPages > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-v2-wrap {
  overflow: visible;
  border-radius: 8px;
  background: theme('colors.white');

  .table-v2__pagination {
    padding: 0 12px 12px;
  }

  &--full-height {
    flex: 1 1 auto;
    align-self: stretch;
  }

  &--flush {
    background: transparent;
    border-radius: 0;

    .table-v2-container {
      background: theme('colors.white');
      border-radius: 8px;
    }

    .table-v2__pagination {
      padding: 0;
    }
  }
}

.table-v2-container {
  overflow: visible;
}

.table-v2 {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-radius: 8px;

  thead,
  tbody {
    border: 0;
  }

  tbody tr {
    border: 0;
  }

  thead tr:first-child th:first-child {
    border-top-left-radius: 8px;
  }

  thead tr:first-child th:last-child {
    border-top-right-radius: 8px;
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 8px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 8px;
  }
}

.table-v2--rtl {
  direction: rtl;

  .table-v2 thead tr:first-child th:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 8px;
  }

  .table-v2 thead tr:first-child th:last-child {
    border-top-right-radius: 0;
    border-top-left-radius: 8px;
  }

  .table-v2 tbody tr:last-child td:first-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 8px;
  }

  .table-v2 tbody tr:last-child td:last-child {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 8px;
  }
}

.table-v2--hover-rows {
  .table-v2 tbody tr:hover {
    background: theme('colors.gray.50');
  }
}
</style>
